/**
 * Offsets alignés sur `Navbar.tsx` + `TopAnnouncementBar` :
 * - invité : h-12 sm:h-14 md:h-14
 * - connecté : h-16 sm:h-20 md:h-20
 * - barre annonce (si visible) : h-10 sm:h-11
 */
export const getHeaderOffsetClasses = (
  isAuthenticated: boolean,
  withTopAnnouncement = true
): string => {
  if (!withTopAnnouncement) {
    return isAuthenticated
      ? "pt-[calc(4rem+env(safe-area-inset-top,0px))] sm:pt-[calc(5rem+env(safe-area-inset-top,0px))] md:pt-[calc(5rem+env(safe-area-inset-top,0px))]"
      : "pt-[calc(3rem+env(safe-area-inset-top,0px))] sm:pt-[calc(3.5rem+env(safe-area-inset-top,0px))] md:pt-[calc(3.5rem+env(safe-area-inset-top,0px))]";
  }

  return isAuthenticated
    ? "pt-[calc(4rem+2.5rem+env(safe-area-inset-top,0px))] sm:pt-[calc(5rem+2.75rem+env(safe-area-inset-top,0px))] md:pt-[calc(5rem+2.75rem+env(safe-area-inset-top,0px))]"
    : "pt-[calc(3rem+2.5rem+env(safe-area-inset-top,0px))] sm:pt-[calc(3.5rem+2.75rem+env(safe-area-inset-top,0px))] md:pt-[calc(3.5rem+2.75rem+env(safe-area-inset-top,0px))]";
};

export const getStickyTopClasses = (
  isAuthenticated: boolean,
  withTopAnnouncement = true
): string => {
  if (!withTopAnnouncement) {
    return isAuthenticated
      ? "top-[calc(4rem+env(safe-area-inset-top,0px))] sm:top-[calc(5rem+env(safe-area-inset-top,0px))] md:top-[calc(5rem+env(safe-area-inset-top,0px))]"
      : "top-[calc(3rem+env(safe-area-inset-top,0px))] sm:top-[calc(3.5rem+env(safe-area-inset-top,0px))] md:top-[calc(3.5rem+env(safe-area-inset-top,0px))]";
  }

  return isAuthenticated
    ? "top-[calc(4rem+2.5rem+env(safe-area-inset-top,0px))] sm:top-[calc(5rem+2.75rem+env(safe-area-inset-top,0px))] md:top-[calc(5rem+2.75rem+env(safe-area-inset-top,0px))]"
    : "top-[calc(3rem+2.5rem+env(safe-area-inset-top,0px))] sm:top-[calc(3.5rem+2.75rem+env(safe-area-inset-top,0px))] md:top-[calc(3.5rem+2.75rem+env(safe-area-inset-top,0px))]";
};
